import React, {Component} from 'react'
import {schools} from '../schools'
import withTheme from 'material-ui/styles/withTheme'
import withStyles from 'material-ui/styles/withStyles'
import TextField from 'material-ui/TextField'
import Paper from 'material-ui/Paper'
import Downshift from 'downshift'
import {styles} from '../styles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography/Typography'
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import Button from 'material-ui/Button'
import {connect} from 'react-redux'
import { MenuItem } from 'material-ui/Menu'

import {FormGroup, FormControlLabel, FormControl, FormHelperText} from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'
import {jobSearchAdd} from './action'
import {universities} from '../universities'
/*
const universities = 
  {
    'จุฬาลงกรณ์มหาวิทยาลัย':
    {
      'คณะแพทยศาสตร์':
      {
        'หลักสูตรแพทยศาสตรบัณฑิต': 
        {
          'jobsTH': ['แพทย์', 'นักนิติวิทยาศาสตร์'],
          'jobsENG': ['Doctor', 'Forensic Scientist'],
          'image': 'หมอ',
        }
      },
      'คณะทันตแพทยศาสตร์':
      {
        'หลักสูตรทันตแพทยศาสตรบัณฑิต':
        {
          'jobsTH': ['ทันตแพทย์'],
          'jobsENG': ['Dentist'],
          'image': 'หมอฟัน',
        } 
      }
    }
  }
*/

function renderInput(inputProps, disabled = false) {
    const { InputProps, classes, ref, ...other } = inputProps;
  
    return (
      <TextField
        disabled={disabled}
        style={{width: '100%'}}
        {...other}
        inputRef={ref}
        InputProps={{
          classes: {
            input: classes.input,
          },
          ...InputProps,
        }}
        
      />
    );
}

function renderUniversity(params) {
    const { university, index, itemProps, highlightedIndex, selectedItem } = params;
    const isHighlighted = highlightedIndex === index;
    const isSelected = selectedItem === university;
  
    return (
      <MenuItem
        {...itemProps}
        key={university}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
          width: '95%'
        }}
      >
        {university}
      </MenuItem>
    );
}

function getUniversities(inputValue) {
    let count = 0;
  
    return Object.keys(universities).filter(university => {
      const keep =
        (!inputValue || university.toLowerCase().includes(inputValue.toLowerCase())) &&
        count < 10;
  
      if (keep) {
        count += 1;
      }
  
      return keep;
    });
  }

  function renderFaculty(params) {
    const { faculty, index, itemProps, highlightedIndex, selectedItem } = params;
    const isHighlighted = highlightedIndex === index;
    const isSelected = selectedItem === faculty;
  
    return (
      <MenuItem
        {...itemProps}
        key={faculty}
        selected={isHighlighted}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
          width: '95%'
        }}
      >
        {faculty}
      </MenuItem>
    );
}

function getFaculties(inputValue, university) {
  let count = 0;
  //console.log(inputValue);
  return Object.keys(universities[university]).filter(faculty => {
    const keep =
      (!inputValue || faculty.toLowerCase().includes(inputValue.toLowerCase())) &&
      count < 10;

    if (keep) {
      count += 1;
    }

    return keep;
  });
}
  
function renderDepartment(params) {
  const { department, index, itemProps, highlightedIndex, selectedItem } = params;
  const isHighlighted = highlightedIndex === index;
  const isSelected = selectedItem === department;

  return (
    <MenuItem
      {...itemProps}
      key={department}
      selected={isHighlighted}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
        width: '95%'
      }}
    >
      {department}
    </MenuItem>
  );
}

function getDepartments(inputValue, university, faculty) {
let count = 0;
//console.log(university, faculty);
return Object.keys((universities[university])[faculty]).filter(department => {
  const keep =
    (!inputValue || department.toLowerCase().includes(inputValue.toLowerCase())) &&
    count < 10;

  if (keep) {
    count += 1;
  }

  return keep;
});
}
function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, 'g'), replace)
}
function getJobs(jobs,jobsENG, checked) {

  if(checked.includes(-1)) {
    checked.splice(checked.indexOf(-1),1)
  }
  let result = new Array()
  for(let c of checked) {
    //console.log('-------------------',jobsENG[c])
    result.push({jobTH: jobs[c], jobENG: replaceAll(replaceAll(jobsENG[c],',',''),'/','')})
  }
  return result
}
class SearchContainer extends Component {
  state={
    university: "",
    faculty: "",
    department: "",
    checked: new Array(),
    name: ""
  }

  handleCheck(index) {
    if(index === -1)
    {
      if(this.state.checked.includes(index)) {
        this.setState({checked: new Array()})
      } else {
        this.setState({checked: [-1, ...Array(this.state.jobs.length).keys()]})
      }
    } else {
      let checkState = this.state.checked.slice()
      //console.log('--checkedstate--',checkState)

      if(checkState.includes(-1)) {
        checkState.splice(checkState.indexOf(-1),1)
      }
      if(this.state.checked.includes(index)) {
        checkState.splice(this.state.checked.indexOf(index),1)
        //this.state.checked.indexOf(index))
        //console.log(checkState)
      } else {
        checkState.push(index)
      }
      this.setState({checked: checkState})
    }
  }
  componentDidMount() {
    //this.setState({university: 'มหาวิทยาลัยธุรกิจบัณฑิตย์'})
  }
  render(){
    const classes = this.props.classes
    return (
        <div>
          {
            //console.log('-----SEARCH CONTAINER-----',this.state)
          }
          <Grid container style={{marginTop: "0px"}} className={this.props.classes.centerGrid} spacing={0}>
            <Grid item xs={12} md={4} className={this.props.classes.itemGrid}>
              <Typography type="title" color="default" >
                ค้นหาสาขาวิชาที่สนใจ
              </Typography>
              
              
              <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                <Downshift 
                  style={{width: '95%'}}
                  onChange={selection=>this.setState({university: selection, faculty: '', department: ''})}>
                  {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
                    <div >
                      {renderInput({
                        fullWidth: true,
                      classes,
                        InputProps: getInputProps({
                          placeholder: 'ค้นหามหาวิทยาลัย',
                          id: 'integration-downshift',
                        }),
                      }, false)}
                      {isOpen ? (
                        <Paper square style={{width: '95%'}}>
                          {getUniversities(inputValue).map((university, index) =>
                            renderUniversity({
                              university,
                              index,
                              itemProps: getItemProps({ item: university }),
                              highlightedIndex,
                              selectedItem,
                            }),
                          )}
                        </Paper>
                      ) : null}
                    </div>
                  )}
                </Downshift>
              </FormControl>  
              {!this.state.university?null
              :
              <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                <Downshift 
                  style={{width: '95%'}}
                  onChange={selection=>this.setState({faculty: selection, department: ''})}>
                  {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
                    <div >
                      {renderInput({
                        fullWidth: true,
                        classes,
                        InputProps: getInputProps({
                          placeholder: `ค้นหาคณะใน ${this.state.university}`,
                          id: 'integration-downshift',
                        }),
                      })}
                      {isOpen ? (
                        <Paper square style={{width: '95%'}}>
                          {getFaculties(inputValue, this.state.university).map((faculty, index) =>
                            renderFaculty({
                              faculty,
                              index,
                              itemProps: getItemProps({ item: faculty }),
                              highlightedIndex,
                              selectedItem,
                            }),
                          )}
                        </Paper>
                      ) : null}
                    </div>
                  )}
                </Downshift>
              </FormControl>  
              }

              {!this.state.university || !this.state.faculty?null
              :
              <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                <Downshift 
                  style={{width: '95%'}}
                  onChange={selection=>{
                    this.setState({
                      department: selection,
                      jobs: universities[this.state.university][this.state.faculty][selection]['jobsTH'],
                      jobsENG: universities[this.state.university][this.state.faculty][selection]['jobsENG'],
                      image: universities[this.state.university][this.state.faculty][selection]['image'],
                      name: universities[this.state.university][this.state.faculty][selection]['name']
                    })
                    //console.log(universities[this.state.university][this.state.faculty][selection])
                  }}
                >
                  {({ getInputProps, getItemProps, isOpen, inputValue, selectedItem, highlightedIndex }) => (
                    <div >
                      {renderInput({
                        fullWidth: true,
                        classes,
                        InputProps: getInputProps({
                          placeholder: `ค้นหาสาขาวิชาใน ${this.state.faculty}`,
                          id: 'integration-downshift',
                        }),
                      })}
                      {isOpen ? (
                        <Paper square style={{width: '95%'}}>
                          {getDepartments(inputValue, this.state.university, this.state.faculty).map((department, index) =>
                            renderDepartment({
                              department,
                              index,
                              itemProps: getItemProps({ item: department }),
                              highlightedIndex,
                              selectedItem,
                            }),
                          )}
                        </Paper>
                      ) : null}
                    </div>
                  )}
                </Downshift>
              </FormControl>  
              }
              
              {!this.state.university || !this.state.faculty || !this.state.department || !this.state.jobs?null
              :
              <FormControl fullWidth style={{width: '95%'}} className={this.props.classes.formControl}>
                <FormHelperText>เลือกอาชีพที่สนใจ หรือเลือกทั้งหมด</FormHelperText>
                <FormGroup>
                <FormControlLabel
                  key={-1}
                    control={
                      <Checkbox 
                        key={-1}
                        value={String(-1)}
                        onChange={()=>this.handleCheck(-1)}
                        checked={this.state.checked.includes(-1)}
                        //checked={String(this.state.checked.includes(index))}
                      />
                    }
                    label='ทั้งหมด/ไม่แน่ใจ/อื่นๆ'
                  />
                
                  {
                    this.state.jobs.map((job, index) => {
                      return(
                        <FormControlLabel
                        key={index}
                          control={
                            <Checkbox 
                              key={index}
                              checked={true}
                              value={String(index)}
                              onChange={()=>this.handleCheck(index)}
                              checked={this.state.checked.includes(index)}
                            />
                          }
                          label={job}
                        />
                        )
                    })
                  }
                </FormGroup>
              </FormControl>
              
              }
              <FormControl  fullWidth className={this.props.classes.formControl}>
                <Button  
                    disabled={
                      !this.state.university || !this.state.faculty || !this.state.department ||
                      this.state.checked.length === 0 //|| !this.state.school
                    }
                    variant="raised"
                    size="large"
                    color="secondary"
                    className={this.props.classes.fullButton}
                    onClick={()=>this.props.dispatch(jobSearchAdd(
                      this.state.university,
                      this.state.faculty,
                      this.state.department,
                      getJobs(this.state.jobs,(this.state.jobsENG), this.state.checked),
                      this.state.image,
                      this.props.profile.jobs,
                      this.state.name
                    ))}
                  >
                    
                    <span style={{fontSize: '120%'}}>
                        เพิ่มข้อมูล
                    </span>
                </Button>
                {
                  //console.log(this.props.profile)
                }
              </FormControl>
            </Grid>
          </Grid>
        </div>
    )
  }
}
export default compose(
  firebaseConnect(),
  withTheme(),
  withStyles(styles),
  connect( ({firebase: {profile}})=>({profile})))(SearchContainer)


// WEBPACK FOOTER //
// ./src/search/SearchContainer.js